<template>
  <div
    data-test-id="offer-details"
    class="relative bg-white px-4 py-6 rounded max-w-116 mx-auto w-full"
    :class="{ 'border-blue border-solid border-4': showBorder }"
  >
    <div
      data-test-id="savings-badge"
      class="bg-raspberry text-white font-medium absolute px-2 py-1 -top-4 rounded"
      v-html="
        $t('pages.coupon.discountBadge', {
          amount: discountValue
        })
      "
    />
    <div
      v-if="trialDays"
      data-test-id="trial-badge"
      class="absolute flex items-center justify-center text-white font-bold -top-24 right-0 w-31 h-31 transform rotate-20 l:w-34 l:h-34 l:-right-20 l:-top-16"
    >
      <star-badge class="text-orchid-violet w-31 h-31 l:w-34 l:h-34 absolute" />
      <span class="z-10 text-center px-4 text-h4" v-html="$t('pages.coupon.freeTrial', { trialDays })" />
    </div>
    <div
      data-test-id="offer-name"
      class="uppercase font-bold text-h4 text-midnight mb-6 text-center"
      v-html="offerNameWithFallback"
    />
    <div class="text-dark-grey flex items-center justify-center mb-8">
      <span class="text-raspberry text-h35 line-through">
        <slot name="originalPrice" />
      </span>
      <span class="font-bold text-h3 ml-2 mr-1">
        <slot name="discountedPrice" />
      </span>
      <span class="font-medium" v-if="subscriptionPeriod"> / {{ subscriptionPeriod }} </span>
    </div>
    <slot name="cta" />
    <div v-for="advantage of advantagesWithFallback" :key="advantage" class="flex mb-4 last:mb-0">
      <check-icon class="text-blue w-6 h-6 mr-2 flex-shrink-0" />
      <span v-html="advantage" class="text-h5 text-dark-grey" />
    </div>
  </div>
</template>

<script>
import StarBadge from "@/component-library/icons/star-badge"
import CheckIcon from "@/component-library/icons/check-icon"
import globals from "@/utils/globals"

export default {
  name: "OfferBox",
  components: {
    CheckIcon,
    StarBadge
  },
  props: {
    advantages: {
      type: Array
    },
    trialDays: {
      type: Number,
      default: 7
    },
    offerName: {
      type: String,
      required: true
    },
    subscriptionPeriod: {
      type: String
    },
    showBorder: {
      type: Boolean,
      default: true
    },
    discountValue: {
      type: String
    }
  },
  computed: {
    advantagesWithFallback() {
      return (this.advantages || this.$t("pages.coupon.defaultAdvantages")).map((item) =>
        item.replace(/{totalBlinks}/g, globals.totalBooks)
      )
    },
    offerNameWithFallback() {
      return this.offerName || this.$t("pages.coupon.defaultOfferName")
    }
  }
}
</script>
